/* ==========================================================================
   FNDRY — Collection
   Plain JS, no framework. Hover image zones, quick add to cart, sort select.
   Card idiom shared with fndry-selected-products.
   ========================================================================== */

(function () {
  'use strict';

  var ROOT = '[data-fndry-col]';
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- helpers -------------------------------------------------- */

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ---------- sort ------------------------------------------------------ */
  /* The form is a plain GET form so sorting works with no JS at all — the
     Apply button submits it. With JS, changing the select submits and the
     button is hidden. */

  function bindSort(root) {
    $$('[data-fndry-col-sortform]', root).forEach(function (form) {
      var select = $('[data-fndry-col-sort]', form);
      var apply = $('[data-fndry-col-sort-apply]', form);
      if (!select) return;

      if (apply) apply.hidden = true;

      select.addEventListener('change', function () {
        form.submit();
      });
    });
  }

  /* ---------- hover image zones ---------------------------------------- */

  function bindZones(root) {
    $$('[data-fndry-col-media]', root).forEach(function (media) {
      var layers = $$('[data-fndry-col-layer]', media);
      if (layers.length < 2) return;

      function show(index) {
        layers.forEach(function (layer, i) {
          layer.classList.toggle('is-active', i === index);
        });
      }

      media.addEventListener('pointermove', function (event) {
        if (!canHover.matches) return;
        var rect = media.getBoundingClientRect();
        if (rect.width === 0) return;
        var pos = (event.clientX - rect.left) / rect.width;
        var zone = Math.floor(pos * layers.length);
        show(Math.min(layers.length - 1, Math.max(0, zone)));
      });

      media.addEventListener('pointerleave', function () {
        show(0);
      });

      // keyboard users get the primary image, never a stuck secondary
      media.addEventListener('focus', function () {
        show(0);
      });
    });
  }

  /* ---------- add to cart ----------------------------------------------- */
  /* The added state is derived from the cart, not from the click. So it
     survives a reload, and it clears itself the moment the line item is
     removed anywhere on the site. */

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setAdded(button, on) {
    button.classList.toggle('is-added', on);
    button.disabled = on;
    var label = on ? button.dataset.addedLabel : button.dataset.addLabel;
    if (label && button.hasAttribute('aria-label')) button.setAttribute('aria-label', label);
  }

  function applyCart(cart) {
    var inCart = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      inCart[item.variant_id] = true;
    });

    $$('[data-fndry-col-atc]').forEach(function (button) {
      setAdded(button, inCart[parseInt(button.dataset.variantId, 10)] === true);
    });
  }

  var cartRequest = null;

  function refreshCart(force) {
    if (!cartRequest || force) {
      cartRequest = fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }
    return cartRequest.then(function (cart) {
      if (cart) applyCart(cart);
      return cart;
    });
  }

  function bindCart(root) {
    var addUrl = root.dataset.cartAddUrl || '/cart/add';

    $$('[data-fndry-col-atc]', root).forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (button.disabled || button.classList.contains('is-added')) return;

        var id = parseInt(button.dataset.variantId, 10);
        if (!id) return;

        button.setAttribute('aria-busy', 'true');

        fetch(addUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript'
          },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add-to-cart failed');
            return response.json();
          })
          .then(function () {
            return refreshCart(true);
          })
          .then(function (cart) {
            // the header / cart drawer listens for this
            document.dispatchEvent(
              new CustomEvent('fndry:cart:updated', {
                detail: { cart: cart, variantId: id, source: 'fndry-collection' }
              })
            );
          })
          .catch(function () {
            window.location.href = root.dataset.cartUrl || '/cart';
          })
          .finally(function () {
            button.removeAttribute('aria-busy');
          });
      });
    });
  }

  /* Anything else on the site that changes the cart should either dispatch
     fndry:cart:updated with a cart object, or fndry:cart:refresh with nothing. */

  document.addEventListener('fndry:cart:updated', function (event) {
    if (event.detail && event.detail.cart) {
      applyCart(event.detail.cart);
    } else {
      refreshCart(true);
    }
  });

  document.addEventListener('fndry:cart:refresh', function () {
    refreshCart(true);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshCart(true);
  });

  /* ---------- init ------------------------------------------------------ */

  function init(root) {
    if (!root || root.dataset.fndryColReady === 'true') return;
    root.dataset.fndryColReady = 'true';

    bindSort(root);
    bindZones(root);
    bindCart(root);
    refreshCart(false);
  }

  function initAll(scope) {
    $$(ROOT, scope || document).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
